import { ReactElement } from 'react';
import { Container as ToqioContainer, CONTAINER_TYPE } from '@toqio/toqio-web-components';

import { ShadowedContainerProps, BorderdContainerProps } from './container.type';

export const ShadowedContainer = ({
  children,
  shadowType = 1,
  shadowBackground,
  onClick,
  className = '',
  style = {},
}: ShadowedContainerProps): ReactElement => {
  return (
    <ToqioContainer
      type={CONTAINER_TYPE.SHADOW}
      onClick={onClick}
      shadowType={shadowType}
      shadowBackground={shadowBackground}
      className={className}
      style={style}
    >
      {children}
    </ToqioContainer>
  );
};

export const BorderedContainer = ({
  children,
  borderColor,
  borderBackground,
  onClick,
  className = '',
  style = {},
}: BorderdContainerProps): ReactElement => {
  return (
    <ToqioContainer
      type={CONTAINER_TYPE.BORDER}
      onClick={onClick}
      borderColor={borderColor}
      borderBackground={borderBackground}
      className={className}
      style={style}
    >
      {children}
    </ToqioContainer>
  );
};
